<template>
  <van-popup v-model="mShow" @close="close" @click-overlay="close">
    <div class="dialog column">
      <van-swipe  v-if="mShow" class="swipe" :loop="false" :show-indicators="false" indicator-color="white" @change="swipeChange">
        <van-swipe-item v-for="(item, index) in shareData.images" :key="index" >
            <div class="imgBox" :id="'item_'+index">
                <img :src="item" alt="" class="img" />
                <div class="qrBox">
                    
                    <img class="qrImg" :src="shareData.appShareImage"/>
                    <div class="inviteCode">{{ shareData.invitation }}</div>
                </div>
            </div>
        </van-swipe-item>
      </van-swipe>
    </div>

  </van-popup>
</template>

<script>
import { Toast } from 'vant';
export default {
  props: {
    show: {
      default: false,
    },
  },
  watch: {
    show(value) {
      this.mShow = value;
      if(this.mShow){
        setTimeout(()=>{
            Toast({message:"请自行截图保存～"})
        },1000)
      }
    },
  },
  data() {
    return {
      mShow: false,
      shareData: {},
      itemId:"item_"+0,
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    close() {
      this.mShow = false;
      this.$emit("close");
    },
    onLoad() {
      this.$request.GET({
        url: "app/share",
        success: (obj) => {
          this.shareData = obj;
        },
      });
    },
    swipeChange(index){
        this.itemId = "item_"+index
        
    },
    
  },
};
</script>

<style  scoped>
.dialog {
  width: 400px;
  
}
.swipe {
  width: 400px;
}
.img {
  width: 320px;
  object-fit: contain;
}
.imgBox{
    width: 320px;
}
.btn {
  margin-top: 12px;
  width: 120px;
  height: 40px;
}
.column {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.qrBox{
    position: absolute;
    left: 66px;
    right: 0;
    bottom: 16px;
    margin: auto;
    display: flex;
  flex-direction: row;
}
.inviteCode{
    border-radius: 3px;
    font-size: 22px;
    font-weight: 700;
    color: black;
    height: 20px;
    line-height: 20px;
    min-width: 80px;
    margin-left: 19px;
    margin-top: 30px;
}
.qrImg{
    margin-top: 4px;
    width: 100px;
    height: 100px;
}
>>>.van-swipe-item {
    position: relative;
    -webkit-flex-shrink: 0;
    flex-shrink: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

</style>